export const userMixin = {
  methods: {
    async logout() {
      await localStorage.removeItem("auth_token");
      await localStorage.removeItem("vuex");
      await window.location.replace("#/login");
    },
    swapLeg(leg) {
      leg = leg === "left" ? false : true;
      this.loading = true;
      this.sendUserdata({ right: leg });
    },
    sendUserdata(object) {
      this.$http({
        method: "put",
        url: "/api/v1/client/users/" + this.$store.getters.currentUser.uuid,
        data: object,
        headers: {
          "content-type": "application/json",
          Authorization: this.$store.getters.authToken,
        },
      })
        .then((response) => {
          this.$store.commit("setCurrentUser", response.data);
          this.$notify({
            type: "success",
            message: "Updated! !",
          });
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$notify({
                type: "danger",
                message: m,
              });
            });
          this.loading = false;
        });
    },
  },
};
